import { ProgressBar } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Container from "../Container";

type Props = {
	progress: number;
};

const ProgressSection = ({ progress }: Props) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();

	return (
		<Container
			containerStyle={{
				paddingHorizontal: isMobile ? 16 : 0,
				paddingVertical: 8,
			}}
			maxWidth="xs"
			autoSize
		>
			<ProgressBar
				progress={progress}
				style={{
					borderRadius: theme.roundness,
				}}
			/>
		</Container>
	);
};

export default ProgressSection;
